import React from "react";
import JTLogo from "./JTLogo";

export const SiteFooter = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t mt-24"
      style={{ borderColor: "rgba(201,162,75,0.15)" }}
    >
      <div className="max-w-[820px] mx-auto px-6 py-20 text-center flex flex-col items-center">
        <JTLogo size={56} />

        <div
          className="font-label mt-8"
          style={{
            color: "var(--jt-ivory)",
            fontSize: "12px",
            letterSpacing: "0.5em",
          }}
        >
          JUMPSEAT THERAPY
        </div>

        <div
          className="font-label mt-5"
          style={{
            color: "var(--jt-gold)",
            fontSize: "11px",
            letterSpacing: "0.42em",
          }}
        >
          ARRIVE &nbsp;·&nbsp; CONNECT &nbsp;·&nbsp; REPEAT
        </div>

        <div className="gold-divider mt-10 mb-10" />

        <p
          className="font-editorial italic"
          style={{
            color: "var(--jt-bone)",
            fontSize: "17px",
            lineHeight: 1.7,
          }}
        >
          Private Members Community
        </p>

        <p
          className="font-editorial italic"
          style={{
            color: "var(--jt-silver)",
            fontSize: "16px",
            lineHeight: 1.7,
          }}
        >
          Verified Flight Attendants Only
        </p>

        <div
          className="font-label mt-12"
          style={{
            color: "var(--jt-mute)",
            fontSize: "11px",
            letterSpacing: "0.38em",
          }}
        >
          2026
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
